@if (name) {
<div
  class="environment-banner"
  [attr.data-environment]="slug"
  role="status"
  aria-live="off"
>
  <span class="environment-banner__label">{{ name }}</span>
</div>
}
